import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';

import { t } from '../../../../../../modules/infra/i18n';
import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import { AUTO_PAYOUT_ELIGIBILITY_ACTIVE_FINANCING_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withProps(() => ({
    name: t('settings:auto_payout.no_capital_financing'),
    description: t('settings:auto_payout.complete_financing_process'),
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_ACTIVE_FINANCING_URL,
    eligibilityActionDescription: t('settings:auto_payout.go_to_financing'),
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      props.router.push('/financing');
    },
  })),
)(AutoPayoutEligibilityStep);
